import { Organisation } from "../models/organisation";
import axiosConfig from "./axiosConfig";

const putOrganisation = async (
  authToken: string,
  orgId: string,
  update: { organisation: Partial<Organisation> }
): Promise<Organisation> => {
  const { data } = await axiosConfig.put(`/organisation/${orgId}`, update, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default putOrganisation;
